export default __webpack_public_path__ + "static/media/fad-sliderhandle-2.e8ee2aae.svg";